<div>
  <table mat-table
         [dataSource]="dataSource"
         *ngIf="dataSource?.data?.length !== 0"
         class="w-100"
         matSort
         cdkDropList
         (cdkDropListDropped)="drop($event)">

    <!-- Coluna: Questão -->
    <ng-container matColumnDef="questao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Questão</th>
      <td mat-cell *matCellDef="let element; let i = index">
        {{ element?.ordem }} - {{ element?.nome }}
      </td>
    </ng-container>

    <!-- Coluna: Critério aplicável -->
    <ng-container matColumnDef="legislacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Critério aplicável</th>
      <td mat-cell *matCellDef="let element">
        <div style="overflow: hidden;" [innerHTML]="element?.legislacaoAplicavelCriterio"></div>
      </td>
    </ng-container>

    <!-- Coluna: Ações -->
    <ng-container matColumnDef="acoes">
      <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
      <td mat-cell *matCellDef="let element; let index">
        <div class="w-100 d-flex justify-content-center">
          <button class="icon-btn btn btn-info btn-xs" (click)="modalEditarQuestao(element, true)">
            <i class="far fas fa-eye"></i>
          </button>
          <button type="button" *ngIf="isPlanejamento && !visualizar && !element?.readonly"
                  class="btn btn-primary btn-xs ml-1" (click)="modalEditarQuestao(element)">
            <i class="fas fa-pen"></i>
          </button>
          <button type="button" *ngIf="isPlanejamento && !visualizar && !element?.readonly"
                  class="btn btn-danger btn-xs ml-1" (click)="excluirQuestao(element?.id)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <!-- Cabeçalho da Tabela -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <!-- Linhas com Drag habilitado -->
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        cdkDrag
        [cdkDragData]="row">
    </tr>
  </table>

  <!-- Sem dados -->
  <h5 *ngIf="dataSource?.data?.length === 0" class="table-no-data">
    Nenhum registro encontrado.
  </h5>

  <!-- Paginador -->
  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>
